import { render } from "./EditInscriptionView.vue?vue&type=template&id=5f46a29f"
import script from "./EditInscriptionView.vue?vue&type=script&lang=js"
export * from "./EditInscriptionView.vue?vue&type=script&lang=js"

import "./EditInscriptionView.vue?vue&type=style&index=0&id=5f46a29f&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__